import riskApi from '@Apis/risk.api';
import { type Metadata } from '@Types/risk.types';

export const getAssetMetadataApi = (assetType: string, param: string) => {
	const address = `/lof/field/score?assetType=${assetType}&fieldName=${param}`;
	return riskApi.get<Metadata[], string>(address);
};
